import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { LockOutlined, DashboardOutlined, CloudDownloadOutlined, PersonAddOutlined, HelpOutlineOutlined } from '@mui/icons-material';
import type { SupportCategory } from '../../types';
import { SUPPORT_CATEGORIES } from '../../config/support';

const ICONS = { login: LockOutlined, 'study-dashboard': DashboardOutlined,
  'data-extraction': CloudDownloadOutlined, enrollment: PersonAddOutlined, other: HelpOutlineOutlined };

interface CategorySelectorProps {
  selected: SupportCategory | null;
  onSelect: (category: SupportCategory) => void;
}

export default function CategorySelector({ onSelect }: CategorySelectorProps) {
  return <Box>
    <Typography variant="body2" sx={{ mb: 1.5 }}>What do you need help with?</Typography>
    <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0, 1fr))', gap: 1 }}>
      {(Object.keys(SUPPORT_CATEGORIES) as SupportCategory[]).map(id => {
        const Icon = ICONS[id];
        return <Button key={id} variant="outlined" startIcon={<Icon />} onClick={() => onSelect(id)}
          sx={{ justifyContent: 'flex-start', textAlign: 'left', minHeight: 64, textTransform: 'none', borderRadius: 2 }}>
          {SUPPORT_CATEGORIES[id].label}
        </Button>;
      })}
    </Box>
  </Box>;
}
